import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { isGeneralFunctionExpression, validateFunction } from "./validations.js";
import { parseEventHandler } from "./parseEvent.js";
export function parseUseImperativeHandle(expr, templateRef, state, app, options) {
  if (!templateRef) {
    state.errors.push({
      message: "useImperativeHandle() can only be used in component with ref parameter",
      node: expr.node,
      severity: "error"
    });
    return null;
  }
  var args = expr.get("arguments");
  if (args.length < 2) {
    state.errors.push({
      message: "useImperativeHandle() requires at least 2 arguments, received ".concat(args.length),
      node: expr.node,
      severity: "error"
    });
    return null;
  }
  var refArg = args[0];
  if (!refArg.isIdentifier() || refArg.scope.getBindingIdentifier(refArg.node.name) !== templateRef.node) {
    state.errors.push({
      message: "useImperativeHandle() first argument must be the ref parameter",
      node: refArg.node,
      severity: "error"
    });
    return null;
  }
  var initArg = args[1];
  if (!initArg.isArrowFunctionExpression()) {
    state.errors.push({
      message: "useImperativeHandle() second argument must be an arrow function expression, received ".concat(initArg.type),
      node: initArg.node,
      severity: "error"
    });
    return null;
  }
  var initBody = initArg.get("body");
  if (!initBody.isObjectExpression()) {
    state.errors.push({
      message: "useImperativeHandle() arrow function body must be an object expression, received ".concat(initBody.type),
      node: initBody.node,
      severity: "error"
    });
    return null;
  }
  var components = [];
  var methods = {};
  var _iterator = _createForOfIteratorHelper(initBody.get("properties")),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prop = _step.value;
      var key = prop.get("key");
      if (!key.isIdentifier()) {
        state.errors.push({
          message: "useImperativeHandle() object property key must be an identifier, received ".concat(key.type),
          node: key.node,
          severity: "error"
        });
        continue;
      }
      var body = void 0;
      if (prop.isObjectProperty()) {
        if (prop.node.computed || prop.node.shorthand) {
          state.errors.push({
            message: "useImperativeHandle() object properties cannot be computed or shorthand",
            node: prop.node,
            severity: "error"
          });
          continue;
        }
        var value = prop.get("value");
        if (!isGeneralFunctionExpression(value)) {
          state.errors.push({
            message: "useImperativeHandle() object properties must be functions, received ".concat(value.type),
            node: prop.node,
            severity: "error"
          });
          continue;
        }
        if (!validateFunction(value.node, state)) {
          continue;
        }
        var fnBody = value.get("body");
        if (!fnBody.isBlockStatement()) {
          state.errors.push({
            message: "useImperativeHandle() object property functions must have a block statement body, received ".concat(fnBody.type),
            node: fnBody.node,
            severity: "error"
          });
          continue;
        }
        body = fnBody;
      } else if (prop.isObjectMethod()) {
        if (prop.node.computed || prop.node.kind !== "method" || prop.node.generator || prop.node.async) {
          state.errors.push({
            message: "useImperativeHandle() object methods must be non-computed non-generator non-async methods, received kind=".concat(prop.node.kind, ", computed=").concat(prop.node.computed, ", generator=").concat(prop.node.generator, ", async=").concat(prop.node.async),
            node: prop.node,
            severity: "error"
          });
          continue;
        }
        body = prop.get("body");
      } else {
        state.errors.push({
          message: "useImperativeHandle() object properties must be methods or properties, received ".concat(prop.type),
          node: prop.node,
          severity: "error"
        });
        continue;
      }
      var handlers = parseEventHandler(body, state, app, options);
      if (handlers && (!Array.isArray(handlers) || handlers.length > 0)) {
        var ref = "imperative-handle-ref-".concat(key.node.name);
        methods[key.node.name] = {
          ref: ref,
          refMethod: "trigger"
        };
        components.push({
          name: "eo-event-agent",
          portal: true,
          properties: {},
          ref: ref,
          events: {
            trigger: handlers
          }
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (components.length === 0) {
    return null;
  }
  return {
    components: components,
    methods: methods
  };
}
//# sourceMappingURL=parseUseImperativeHandle.js.map